import React from 'react';
import PropTypes from 'prop-types';
// import { css } from '@bd/bdui-styles/emotion';
import { orderBy, get } from 'lodash';
import withData from '@bd/bdcore-data';

import HomeCard from './HomeCard';

const HomesResults = ({ homes, sort, limit }) => {
  return (
    <div className="list-background-color">
      <div className="container">
        <div className="row HomeCardsList Vertical">
          {
            orderBy(homes, sort.field, get(sort, 'dir'), 'asc').slice(0, limit).map(home => (
              <div className="col-sm-12 col-md-6 col-lg-4 col-xl-3 mb-3" key={home._id}>
                <HomeCard home={home} />
              </div>
            ))
          }
        </div>
        {
          limit < homes.length &&
          <div style={{ textAlign: 'center' }}>
            <button className="btn" onClick={this.showMore}>Load More</button>
          </div>
        }
      </div>
    </div>
  );
};

HomesResults.propTypes = {
  homes: PropTypes.arrayOf(PropTypes.object),
  sort: PropTypes.object,
  limit: PropTypes.number,
};

HomesResults.defaultProps = {
  homes: [],
  sort: null,
  limit: null,
};


export default withData(
  {
    homes: true,
  },
)(HomesResults);



// WEBPACK FOOTER //
// ./src/pages/HomesOriginal/HomesResults.js